import { TaxiAchievementApiTaxiAchievementDeleteRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiAchievementDeleteMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiAchievementApiTaxiAchievementDeleteRequest, config) =>
      appApiClient.taxiAchievementApi.taxiAchievementDelete(req, config),
  });
